export const styles = {
  options: {
    zIndex: 10000,
    primaryColor: '#4f46e5', // indigo-600 to match theme
    backgroundColor: '#ffffff',
    textColor: '#334155', // slate-700
    overlayColor: 'rgba(0, 0, 0, 0.5)',
    arrowColor: '#ffffff',
    fontFamily: "'Istok Web', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  tooltip: {
    borderRadius: '0.75rem', // rounded-xl
    padding: '1.25rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  },
  tooltipContainer: {
    textAlign: 'left',
  },
  tooltipTitle: {
    fontSize: '1.125rem', // text-lg
    fontWeight: '700',
    color: '#1e293b', // slate-800
    marginBottom: '0.5rem',
  },
  tooltipContent: {
    fontSize: '0.875rem', // text-sm
    lineHeight: '1.5',
    color: '#475569', // slate-600
    padding: '0.5rem 0',
  },
  buttonNext: {
    backgroundColor: '#2DD4BF', // indigo-600 (primary color)
    color: '#ffffff',
    borderRadius: '0.5rem', // rounded-lg
    padding: '0.625rem 1.25rem',
    fontSize: '0.875rem',
    fontWeight: '600',
    border: 'none',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s',
  },
  buttonBack: {
    backgroundColor: '#f1f5f9', // slate-100
    color: '#475569', // slate-600
    borderRadius: '0.5rem',
    padding: '0.625rem 1.25rem',
    fontSize: '0.875rem',
    fontWeight: '600',
    border: 'none',
    marginRight: '0.5rem',
  },
  buttonSkip: {
    color: '#64748b', // slate-500
    fontSize: '0.875rem',
    fontWeight: '500',
  },
  buttonClose: {
    color: '#2DD4BF', // primary DEFAULT
    fontSize: '1.5rem',
    fontWeight: '700',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  spotlightPadding: 10,
  spotlightRadius: 12,
  beaconSize: {
    width: '1.5rem',
    height: '1.5rem',
  },
  spotlight: {
    borderRadius: '0.5rem',
  },
  beacon: {
    right: '20px',
  },
  beaconInner: {
    backgroundColor: '#4f46e5', // indigo-600
  },
  beaconOuter: {
    backgroundColor: 'rgba(79, 70, 229, 0.2)',
    borderColor: '#4f46e5',
  },
};

export const locale = {
  back: 'Back',
  close: 'Close',
  last: 'Finish',
  next: 'Next',
  skip: 'Skip',
};

export const MobileSteps = [
  {
    target: '.mobile-tour-dashboard',
    content:
      'Welcome to your Dashboard — your central hub where you can track everything at a glance!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-upgrade-card, .tour-no-posts-card',
    content:
      'Your upcoming posts will appear in this area once you have content scheduled. Upgrade your plan to unlock more post slots and maximize your content strategy!',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-card-for-story',
    content: 'This card shows your Story content — post quick updates on Instagram or Facebook!',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-card-for-feed',
    content:
      'This card displays your Feed posts — plan and preview content for Instagram and Facebook!',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-preview',
    content:
      'This is the post preview area — see how your content will look on Instagram and Facebook before posting!',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.mobile-tour-post-modal-schedule',
    content: 'You can reschedule, edit,give us feedback or regenerate your post from here!',
    placement: 'bottom',
    disableBeacon: true,
  },

  {
    target: '.mobile-tour-social-accounts',
    content:
      'Connect and manage your social media accounts here to keep your content synced and ready to post!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.mobile-tour-content-gallery',
    content:
      'This is your gallery — all your uploaded images are stored here for easy access and reuse!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.mobile-tour-calendar',
    content:
      'Plan your content schedule here — stay organized and never miss an important posting day!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.mobile-tour-calendar-event',
    content:
      'This is a scheduled post event — tap to view details, edit, or reschedule your post as needed!',
    placement: 'top',
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target:
      window.innerWidth < 768
        ? '.mobile-tour-calendar-change-view'
        : '.fc-header-toolbar .fc-toolbar-chunk:last-child .fc-button-group',
    content:
      'Use this button to change your calendar view — switch between month, week, and day views to manage your schedule effectively!',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.mobile-tour-profile',
    content:
      'This is your Profile — customize your public details, showcase your brand, and make it shine!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-summary-section',
    content:
      'Here you can view your profile summary — see key details about your account and performance.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '.tour-edit-summary-button',
    content: 'Click here to edit your profile summary information.',
    placement: 'bottom',
    disableBeacon: true,
  },

  {
    target: '.tour-offerings-section',
    content:
      'This section shows your offerings — manage and showcase the services or products you provide.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '.tour-add-offering-button',
    content: 'Click here to add a new offering.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-edit-delete-offering',
    content: 'Use these buttons to edit or delete this offering.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.mobile-tour-settings',
    content:
      'Here you can adjust your preferences, manage notifications, and fine-tune your account.',
    placement: 'right',
    disableBeacon: true,
  },
];
export const DesktopSteps = [
  {
    target: '.desktop-tour-dashboard',
    content:
      'Welcome to your Dashboard — your central hub where you can track everything at a glance!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-upgrade-card, .tour-no-posts-card',
    content:
      'Your upcoming posts will appear in this area once you have content scheduled. Upgrade your plan to unlock more post slots and maximize your content strategy!',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-card-for-story',
    content: 'This card shows your Story content — post quick updates on Instagram or Facebook!',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-card-for-feed',
    content:
      'This card displays your Feed posts — plan and preview content for Instagram and Facebook!',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-preview',
    content:
      'This is the post preview area — see how your content will look on Instagram and Facebook before posting!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-reschedule',
    content: 'Need to make changes? Use the reschedule option to adjust your posting time easily!',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-social-accounts',
    content:
      'Select which social accounts to post to right from the preview modal! No account connected yet? Go to socials to link one.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-schedule',
    content: 'To schedule your post, you have to have the social accounts connected first.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-feedback',
    content:
      'Not satisfied with your post, or you have some suggestions? Give us your honest feedback.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-post-modal-regenerate',
    content:
      'Not happy with your post? Use the regenerate option to create a new version with different styles or captions!',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.desktop-tour-social-accounts',
    content:
      'Connect and manage your social media accounts here to keep your content synced and ready to post!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.desktop-tour-content-gallery',
    content:
      'This is your gallery — all your uploaded images are stored here for easy access and reuse!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.desktop-tour-calendar',
    content:
      'Plan your content schedule here — stay organized and never miss an important posting day!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.desktop-tour-calendar-event',
    content:
      'This is a scheduled post event — tap to view details, edit, or reschedule your post as needed!',
    placement: 'top',
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: '.fc-header-toolbar .fc-toolbar-chunk:last-child .fc-button-group',
    content:
      'Use this button to change your calendar view — switch between month, week, and day views to manage your schedule effectively!',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.desktop-tour-profile',
    content:
      'This is your Profile — customize your public details, showcase your brand, and make it shine!',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.desktop-tour-summary-section',
    content:
      'Here you can view your profile summary — see key details about your account and performance.',
    placement: 'right',
    disableBeacon: true,
    disableScrollParentFix: true,
  },
  {
    target: '.desktop-tour-summary-section .tour-edit-summary-button',
    content: 'Click here to edit your profile summary information.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrollParentFix: true,
  },

  {
    target: '.desktop-tour-offerings-section',
    content:
      'This section shows your offerings — manage and showcase the services or products you provide.',
    placement: 'right',
    disableBeacon: true,
    disableScrollParentFix: true,
  },
  {
    target: '.tour-add-offering-button',
    content: 'Click here to add a new offering.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrollParentFix: true,
  },
  {
    target: '.desktop-tour-offerings-section .tour-edit-delete-offering',
    content: 'Use these buttons to edit or delete this offering.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrollParentFix: true,
  },
  {
    target: '.desktop-tour-settings',
    content:
      'Here you can adjust your preferences, manage notifications, and fine-tune your account.',
    placement: 'right',
    disableBeacon: true,
  },
];
